import { AnswerApiFactory, AnswerPrintResponse, AnswerPrintRequest } from '@/api'
import { BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'

/**
 * 回答案出力
 */
export class AnswerPrintCreate extends BaseUserActionRequest {
  private requestData: AnswerPrintRequest

  /**
   * @param requestData 申請基本ID、回答案件名、回答相手略称、回答案項目ID
   * @returns
   */
  constructor(requestData: AnswerPrintRequest) {
    super()
    this.requestData = requestData
  }

  protected request(): AxiosPromise<AnswerPrintResponse> {
    const api = AnswerApiFactory()
    return api.answerPrintCreate(this.requestData)
  }
}
